import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';

interface IPostOptions {
		headers?: HttpHeaders | {
			[header: string]: string | string[];
		};
		observe: 'response';
}

export abstract class DataService {

  protected apiServer = '';

	constructor(private http: HttpClient) {}

	protected get<T>(url: string) {
		const promise = new Promise<T>((resolve, reject) => {
			this.http.get(url).toPromise()
					.then((data: any) => {
						this.convertDatesFromApi(data);
						resolve(data);
					})
					.catch((response: any) => {
						reject(response);
					});
			});
			//how about now
			return promise;
	}

	protected post<T>(url: string, body: any) {
		const promise = new Promise<T | string>((resolve, reject) => {
			const headers = new HttpHeaders({
				'Content-Type': 'application/json',
				'Accept': 'application/json'
			});
			const options: IPostOptions = { headers: headers, observe: 'response' };
			this.http.post(url, body, options).toPromise()
					.then((response: any) => {
							const contentType = response.headers.get('Content-Type');
							const newResourceUrl = response.headers.get('Location');
							if (contentType && contentType.indexOf('json') > -1) {
									resolve(<T>response.body);
							} else if (newResourceUrl) {
									resolve(newResourceUrl);
						} else {
								resolve(null as any);
						}
					})
					.catch((response: any) => {
						reject(response);
					});
		});
		return promise;
	}

	private convertDatesFromApi(input: any) {
		const iso8601RegEx = /(19|20|21)\d\d([-/.])(0[1-9]|1[012])\2(0[1-9]|[12][0-9]|3[01])T(\d\d)([:/.])(\d\d)([:/.])(\d\d)/;

		if (!input || typeof input !== 'object') {
			return;
		}

		Object.keys(input).forEach(key => {
			const value = input[key];
			const type = typeof value;
			let match: any;
			if (type === 'string' && (match = value.match(iso8601RegEx))) {
				input[key] = new Date(value);
			} else if (type === 'string' && value === '0001-01-01T00:00:00') {
				input[key] = null;
			} else if (type === 'object') {
				this.convertDatesFromApi(value);
			}
		});
	}
}
